/** FBR IMS official POS invoicing mark (thermal slips, previews, blob print HTML). */
export const FBR_DIGITAL_INVOICING_LOGO_URL = 'https://ims.fbr.gov.pk/images/pos.png'

/** PNG pixel width for QR bitmap generation (~300dpi for 1″ print). */
export const FBR_QR_PRINT_PIXEL_SIZE = 300
